// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
import * as sosI18n from './sosI18n'
export { sosI18n }